import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { forwardRef, ReactNode } from 'react';

/**
 * @heading1: Card Wrapper
 * @heading3: Interfaces
 * @heading4: Card Interface
 * @ol:
 * children {ReactNode}
 * @separator:
 */
interface CardInterface {
    children: ReactNode;
    [key: string]: unknown;
}

/**
 * @heading3: Styled Component
 * @heading4: Styled Box
 * @paragraph: Styles are applying to the Box
 * @separator:
 */
const StyledBox = styled(Box)(({ theme }) => ({
    borderRadius: '10px',
    boxSizing: 'border-box',
    border: '1px solid #ededed',
    backgroundColor: theme.palette.mode === 'dark' ? 'black' : 'white',
    width: '100%',
    margin: '0 auto',
    padding: '15px'
}));

/**
 * @heading2: CardWrapper Component
 * @block_quotes: A reusable Card wrapper with support for same styles of box and Forward ref to the StyledBox.
 * @heading3: Parameter {CardInterface} props
 * @block_quotes: Props for configuring the Card.
 * @separator:
 */
const CardWrapper = forwardRef<HTMLDivElement, CardInterface>(({ children, ...props }, ref) => {
    return (
        <StyledBox ref={ref} {...props}>
            {children as ReactNode}
        </StyledBox>
    );
});

// Set displayName for the component
CardWrapper.displayName = 'CardWrapper';

export default CardWrapper;
